import styled from 'styled-components'

export const Container = styled.div`
	form {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		padding-bottom: 24px;
		grid-template-areas:
			'cpf nome nasc sexo'
			'email rg orgao emiss'
			'rg_arq cpf_arq foto x'
			'action_footer action_footer action_footer action_footer';
	}

	@media(max-width: 1100px) {
		form {
			grid-template-columns: repeat(3, 1fr);
			grid-template-areas:
				'cpf nome nasc'
				'sexo email rg'
				'orgao emiss x'
				'rg_arq cpf_arq foto'
				'action_footer action_footer action_footer';
		}
	}

	@media(max-width: 800px) {
		form {
			grid-template-columns: repeat(2, 1fr);
			grid-template-areas:
				'cpf nome'
				'nasc sexo'
				'email rg'
				'orgao emiss'
				'rg_arq cpf_arq'
				'foto x'
				'action_footer action_footer';
		}
	}

	@media(max-width: 600px) {
		form {
			display: flex;
			flex-direction: column;
		}
	}
`
